import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Terminal } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "@/lib/auth";
import { LOGO_MARK } from "@/lib/assets";
import { btnPrimary, input, label } from "@/lib/styles";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Account created");
      navigate("/onboarding");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center grid-bg px-4">
      <div className="w-full max-w-md bg-zinc-950 border border-zinc-800 p-8 scanlines relative">
        <Link to="/" className="flex items-center gap-2 mb-8"><img src={LOGO_MARK} alt="" className="w-8 h-8" /><span className="font-sans font-bold text-xl tracking-tight text-zinc-100">Prompt<span className="text-gold">bound</span></span></Link>
        <span className={label}>nice to meet you</span>
        <h1 className="mt-2 text-2xl font-black tracking-tight mb-1">Create free account</h1>
        <p className="text-xs text-zinc-500 mb-6">Free to read every topic. 3 graded interviews included.</p>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="register-name" className={input} placeholder="name (optional)" value={name} onChange={(e) => setName(e.target.value)} />
          <input data-testid="register-email" className={input} type="email" placeholder="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <input data-testid="register-password" className={input} type="password" placeholder="password (min 6 chars)" value={password} onChange={(e) => setPassword(e.target.value)} required />
          {err && <p data-testid="register-error" className="text-red-400 text-xs font-mono">! {err}</p>}
          <button data-testid="register-submit" type="submit" disabled={loading} className={`${btnPrimary} w-full`}>{loading ? "creating..." : "Sign up free"}</button>
        </form>
        <p className="mt-6 text-xs text-zinc-500 text-center">Already registered? <Link to="/login" className="text-emerald-400 hover:underline" data-testid="register-to-login">Log in</Link></p>
      </div>
    </div>
  );
}
